<template>
  <div style="width:25%; left:30%; position:relative; margin-top:15px;">
    <Form ref="formValidate" :label-width="120">
      <FormItem label="批次日期">
        <DatePicker type="date" v-model="formValidate.date" format="yyMMdd" placeholder="请选择批次日期"></DatePicker>
      </FormItem>
      <FormItem label="重置地址">
        <Input v-model="formValidate.resetAddress" placeholder="请输入重置地址"></Input>
      </FormItem>
      <FormItem label="重置端口">
        <Input v-model="formValidate.resetPort" placeholder="请输入重置端口"></Input>
      </FormItem>
      <FormItem label="序号区间">
        <Tooltip placement="top" transfer>
          <div slot="content">
            <p>例如 1-28,55,58-99</p>
            <p>表示重置1至28、58至99和55号设备</p>
          </div>
          <Input v-model="formValidate.index" placeholder="请输入序号区间"></Input>
        </Tooltip>
      </FormItem>
    </Form>
    <div style="left:45%; position:relative;">
      <Button style="margin-right:10px" @click="commit" type="primary">提交重置</Button>
      <Button @click="showResult = true" type="primary">查看结果</Button>
    </div>

    <Drawer width="340" title="设备下发重置结果" :closable="false" v-model="showResult">
      <p v-for="(value, key) in array" :key="key" :value="value">
        <span>
          {{value.id + " "}}
          <span v-if="value.state == '等待下发重置'" style="color:blue">{{value.state}}</span>
          <span v-if="value.state == '下发重置成功'" style="color:green">{{value.state}}</span>
          <span
            v-if="value.state != '下发重置成功' && value.state != '等待下发重置'"
            style="color:red"
          >{{value.state}}</span>
        </span>
        <Icon
          color="blue"
          type="ios-loading"
          v-if="value.state == '等待下发重置'"
          size="18"
          class="demo-spin-icon-load"
          style="margin-left:10px"
        ></Icon>
        <Icon
          color="green"
          type="ios-checkmark-circle-outline"
          v-if="value.state == '下发重置成功'"
          size="18"
          style="margin-left:10px"
        ></Icon>
        <Icon
          color="red"
          type="ios-close-circle-outline"
          v-if="value.state != '下发重置成功' && value.state != '等待下发重置'"
          size="18"
          style="margin-left:10px"
        ></Icon>
      </p>
    </Drawer>
  </div>
</template>
<script>
export default {
  name: "meter_reset",
  mounted() {
    this.formValidate.date = global.dateFtt("yyMMdd", new Date());
  },
  methods: {
    setTime(e) {
      this.formValidate.date = e;
    },
    reset(meterArray, address, port) {
      var defer = $.Deferred();
      Object.keys(meterArray).forEach(function(value, i) {
        var meterId = meterArray[value].id;
        var imei = meterArray[value].imei;

        var that = this;
        $.ajax({
          url:
            "/api/resetMeter?meterId=" +
            meterId +
            "&address=" +
            address +
            "&port=" +
            port,
          contentType: "application/json",
          type: "get",
          dataType: "json",
          success: function(data) {
            if (data.errorCode != 0) {
              meterArray[value].state = "网络错误";
              return;
            } else {
              let temp = JSON.parse(data.body);
              if (temp.errorCode == 0) {
                meterArray[value].state = "下发重置成功";
              } else {
                meterArray[value].state = temp.errorInfo;
              }
            }
          },
          error: function(textStatus) {
            that.$Notice.error({
              title: "异常",
              desc: "接口调用异常"
            });
          },
          complete: function(XMLHttpRequest, textStatus) {}
        });
      });
      return defer.promise();
    },

    commit() {
      let meterIdArray = {};

      if (this.formValidate.index != "") {
        let batch = global.dateFtt("yyMMdd", this.formValidate.date);
        this.formValidate.index = this.formValidate.index.trim();
        this.formValidate.index = this.formValidate.index.replace(/，/gi, ",");
        let tempStr = this.formValidate.index;
        let indexArray = tempStr.split(",");

        for (let index = 0; index < indexArray.length; index++) {
          let temp = indexArray[index];
          let tempArray = temp.split("-");
          if (tempArray.length == 1) {
            let tempObject = {};
            let sup = "";
            while ((batch + sup + temp).length < 14) {
              sup = sup + "0";
            }

            tempObject["id"] = batch + sup + temp;
            tempObject["state"] = "等待下发重置";
            meterIdArray[batch + sup + temp] = tempObject;
          }

          if (tempArray.length == 2) {
            for (
              let i = parseInt(tempArray[0]);
              i <= parseInt(tempArray[1]);
              i++
            ) {
              let tempObject = {};
              let sup = "";

              while ((batch + sup + i).length < 14) {
                sup = sup + "0";
              }

              tempObject["id"] = batch + sup + i;
              tempObject["state"] = "等待下发重置";
              meterIdArray[batch + sup + i] = tempObject;
            }
          }
        }

        this.array = meterIdArray;
        this.showResult = true;

        console.log(this.array);

        this.reset(this.array, this.formValidate.resetAddress, this.formValidate.resetPort);
      }else{
		  this.$Modal.info({
          title: "提示",
          content: "请填写正确参数"
        });
	  }
    }
  },
  data() {
    return {
      showResult: false,
      array: {},
      formValidate: {
        date: "",
        index: "",
        resetAddress: "sg.cnzhuocheng.cn",
        resetPort: "80"
      }
    };
  }
};
</script>
<style>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
</style>